export default function numberNoTrail(value, decimals = 2) {
    if (value) {
        return Number(parseFloat(value).toFixed(decimals));
    }
}
